var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.eventClass,style:(_vm.eventBg)},[_c('div',{staticClass:"inner-content pb-5"},[_c('Alert'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }